module.exports = __webpack_public_path__ + "img/s2-1.5951b486.jpg";